import { render, staticRenderFns } from "./WidgetCandidateAssessment.vue?vue&type=template&id=192ee660&scoped=true&lang=pug"
import script from "./WidgetCandidateAssessment.vue?vue&type=script&lang=ts"
export * from "./WidgetCandidateAssessment.vue?vue&type=script&lang=ts"
import style0 from "./WidgetCandidateAssessment.vue?vue&type=style&index=0&id=192ee660&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192ee660",
  null
  
)

export default component.exports